import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Stats from "../components/Stats";
import About from "../components/About";
import PricingTiers from "../components/PricingTiers";
import Process from "../components/Process";
import Gallery from "../components/Gallery";
import CuratedReviews from "../components/CuratedReviews";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import {
  SEO,
  localBusinessSchema,
  serviceSchema,
  faqSchema,
  breadcrumbSchema,
} from "../components/SEO";
import { BRAND } from "../mock";

const FAQS = [
  {
    q: "How much does ceramic coating cost in Vaughan?",
    a: "At Jester Werks our flagship 2-layer ceramic coating with a 1-stage paint correction included is currently $550. a limited content-based offer for select Vaughan vehicles we feature on our channels. The regular price is $1,500. Final pricing depends on vehicle size and paint condition, and we provide a written quote within 24 hours.",
  },
  {
    q: "Where is the best ceramic coating in Vaughan?",
    a: "Jester Werks is the most-reviewed ceramic coating studio serving Vaughan with 250+ verified five-star Google reviews. We hand-apply a premium 2-layer Gtechniq system. Gtechniq Crystal Serum Light + Gtechniq EXO v5. in a climate-controlled bay and warranty every coating in writing for 5 years.",
  },
  {
    q: "Do you serve Woodbridge, Maple and Kleinburg?",
    a: "Yes. we serve every Vaughan neighbourhood including Woodbridge, Maple, Concord, Kleinburg, Thornhill, Patterson, Vellore Village, Sonoma Heights, Carrville, Mackenzie, Pine Valley and Sunny Brook. Free pickup and delivery is available on packages over $1,000.",
  },
  {
    q: "How long does ceramic coating last on a car in Vaughan winters?",
    a: "Vaughan winters are tough on paint. salt, slush and freeze-thaw cycles eat through unprotected clear coat. Our 2-layer Gtechniq ceramic coating creates a glass-deep shield that resists road salt, brake dust and UV oxidation for a full 5 years, and we provide free annual maintenance inspections.",
  },
  {
    q: "What does the $550 ceramic coating offer in Vaughan include?",
    a: "Our Vaughan ceramic coating offer includes: full decontamination prep, a 1-stage paint correction, the 2-layer Crystal Serum Light + EXO v5 system, a free window coating ($150 value), a written 5-year warranty and a documented before/after report. It is a limited content-based offer for vehicles we feature on our channels.",
  },
  {
    q: "Do you offer pickup and delivery in Vaughan?",
    a: "Yes. We offer complimentary pickup and delivery anywhere in Vaughan. Woodbridge, Maple, Kleinburg, Concord, Thornhill, Patterson and beyond. on coating packages over $1,000. Most Vaughan clients have their car picked up the same day they call.",
  },
  {
    q: "How long does the ceramic coating service take?",
    a: "A full 2-layer ceramic coating with paint correction typically takes 2 to 4 days depending on vehicle size and paint condition. We never rush. every panel is inspected under multiple lights and the coating cures under controlled conditions before delivery back to Vaughan.",
  },
  {
    q: "Where is the Vaughan studio located?",
    a: "Our Vaughan studio is at 5732 Hwy 7 #15, Woodbridge, ON L4L 2Z9. easily accessible from Highway 7, the 400, the 407 and Pine Valley Drive. We also operate a Mississauga studio for clients in the western GTA.",
  },
];

const NEIGHBOURHOODS = [
  "Woodbridge", "Maple", "Concord", "Kleinburg", "Thornhill",
  "Patterson", "Vellore Village", "Sonoma Heights", "Carrville",
  "Mackenzie", "Pine Valley", "Sunny Brook",
];

export default function CeramicVaughan() {
  const url = `${BRAND.url}/ceramic-coating-vaughan`;
  return (
    <div className="grain bg-jester-deep text-white">
      <SEO
        title="Ceramic Coating Vaughan | #1 Rated Studio. From $550 | Jester Werks"
        description="Ceramic coating Vaughan from $550. Jester Werks is Vaughan's most-reviewed ceramic coating studio. 250+ verified Google reviews, 1,500+ cars coated, 5-year warranty, free window coating. Serving Woodbridge, Maple, Kleinburg, Concord, Thornhill & all of Vaughan. Call (647) 646-7223."
        canonical={url}
        schemas={[
          localBusinessSchema(),
          serviceSchema({
            name: "Ceramic Coating Vaughan",
            description:
              "Premium 2-layer Gtechniq ceramic coating service in Vaughan, ON. Hand-applied Gtechniq Crystal Serum Light + EXO v5 with 1-stage paint correction, 5-year warranty, free window coating. Serving Woodbridge, Maple, Kleinburg, Concord and all Vaughan neighbourhoods.",
            areaServed: [
              "Vaughan", "Woodbridge", "Maple", "Concord", "Kleinburg",
              "Thornhill", "Patterson", "Vellore Village", "Richmond Hill", "Markham",
            ],
            offers: "550",
          }),
          faqSchema(FAQS),
          breadcrumbSchema([
            { name: "Home", url: `${BRAND.url}/` },
            { name: "Ceramic Coating Vaughan", url },
          ]),
        ]}
      />
      <Navbar />
      <PageHero
        kicker="Vaughan · Woodbridge · 250+ Google Reviews"
        h1="CERAMIC COATING"
        h1Accent="VAUGHAN."
        marker="locked in for 5 years."
        description="Vaughan's most-reviewed Gtechniq ceramic coating studio. Hand-applied 2-layer Gtechniq ceramic with 1-stage paint correction included. now from $550 (regularly $1,500) with a free window coating. Serving Woodbridge, Maple, Kleinburg, Concord & all of Vaughan."
        city="Vaughan"
        bgImage="https://images.unsplash.com/photo-1588508050172-e51cf614535c"
        secondaryCta={{ label: "View Packages", href: "#pricing" }}
      />

      <section className="relative py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           Vaughan's Detail Studio
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-[1] mb-8">
            The boutique <span className="text-jester">ceramic coating</span>{" "}
            studio Vaughan drivers trust.
          </h2>
          <div className="text-white/75 text-lg leading-relaxed space-y-5">
            <p>
              Jester Werks is the <strong className="text-white">most-reviewed
              ceramic coating studio serving Vaughan</strong>. 250+ verified
              five-star Google reviews, 1,500+ cars coated, 20K+ Instagram
              followers and 1M+ monthly content views. We're owner-operated,
              hand-finish every car, and back every coating in writing.
            </p>
            <p>
              Our flagship Vaughan ceramic coating package pairs Gtechniq's
              flagship hard base coat (<em>Gtechniq Crystal Serum Light</em>)
              with a high-gloss hydrophobic top coat (<em>Gtechniq EXO v5</em>)
             a true two-layer Gtechniq system, hand-applied panel by panel
              in our climate-controlled, dust-filtered Vaughan bay on Highway
              7. The Gtechniq coating bonds chemically to your factory clear
              coat to create a glass-deep shield against road salt, slush,
              brake dust, tree sap, bird droppings and UV oxidation. for a
              full five years.
            </p>
            <p>
              Right now we're running a limited{" "}
              <strong className="text-acid">$550 content-based ceramic
              coating offer</strong> (regularly $1,500) for select Vaughan
              vehicles we feature on our channels. The package includes a full
              decontamination prep, 1-stage paint correction, the complete
              2-layer ceramic system, a{" "}
              <strong className="text-white">free window coating</strong>{" "}
              ($150 value) for better rain visibility, a written 5-year
              warranty and a documented before/after report. Spots are
              limited.
            </p>
            <p>
              We serve every Vaughan neighbourhood.{" "}
              <strong className="text-white">
                Woodbridge, Maple, Concord, Kleinburg, Thornhill, Patterson,
                Vellore Village, Sonoma Heights, Carrville, Mackenzie, Pine
                Valley
              </strong>{" "}
              and Sunny Brook. We also serve drivers from{" "}
              <a href="/ceramic-coating-mississauga" className="text-acid underline underline-offset-4 hover:text-white">
                Mississauga
              </a>
              ,{" "}
              <a href="/ceramic-coating-toronto" className="text-acid underline underline-offset-4 hover:text-white">
                Toronto
              </a>
              , Markham, Richmond Hill, North York and the broader GTA. with
              free pickup and delivery within 25 km on packages over $1,000.
            </p>
            <p>
              Whether you searched{" "}
              <em className="text-white/90">"ceramic coating Vaughan"</em>,{" "}
              <em className="text-white/90">"ceramic coating Woodbridge"</em>,{" "}
              <em className="text-white/90">"ceramic coating Maple"</em>, or{" "}
              <em className="text-white/90">"ceramic coating Kleinburg"</em>,
              you've found the highest-rated, most transparent ceramic coating
              studio serving Vaughan. Read{" "}
              <a href="/reviews" className="text-acid underline underline-offset-4 hover:text-white">
                250+ five-star Google reviews
              </a>{" "}
              and request your free written quote. delivered in under 24 hours.
            </p>
          </div>
        </div>
      </section>

      <section className="relative py-16 border-y border-white/5 bg-[#0c0119]" data-testid="vaughan-neighbourhoods-section">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-4 font-label">
           Vaughan neighbourhoods we serve
          </div>
          <h3 className="font-display text-2xl md:text-3xl mb-8">
            Ceramic coating <span className="text-jester">across all of Vaughan.</span>
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {NEIGHBOURHOODS.map((n, i) => (
              <span
                key={i}
                data-testid={`vaughan-hood-${i}`}
                className="px-4 py-2 rounded-full border border-white/10 bg-jester-card text-sm text-white/80 hover:border-acid/50 hover:text-acid transition-colors"
              >
                {n}
              </span>
            ))}
          </div>
          <p className="mt-8 text-sm text-white/50">
            Free pickup &amp; delivery on packages over $1,000 anywhere in Vaughan.
          </p>
        </div>
      </section>

      <Stats />
      <PricingTiers city="Vaughan" />
      <About />
      <Process />
      <Gallery />
      <CuratedReviews />
      <FAQ items={FAQS} />
      <Contact />
      <Footer />
    </div>
  );
}
